export const findRubricInTreeByName = (rubricsTree, name) => {
	const rubricChildren = rubricsTree?.children;

	if (!name || rubricsTree.name === name) {
		return rubricsTree;
	}

	if (Array.isArray(rubricChildren) && rubricChildren.length > 0) {
		const rubric = rubricChildren.find((node) =>
			findRubricInTreeByName(node, name)
		);

		return rubric ?? null;
	}
};

export const findRubricInTreeBySomeField = (rubricsTree, fieldName, value) => {
	if (rubricsTree[fieldName] === value) {
		return rubricsTree;
	}

	const rubricChildren = rubricsTree?.children;

	// eslint-disable-next-line no-restricted-syntax
	for (const node of rubricChildren) {
		const rubric = findRubricInTreeBySomeField(node, fieldName, value);
		if (rubric) {
			return rubric;
		}
	}
};

const entitiesWithViewsSort = [
	'books',
	'circuses',
	'cultureHeritageObjects',
	'foreignHeritageObjects',
	'musicalGroups',
	'parks',
	'persons',
	'religionHeritageObjects',
	'russiaImages',
	'terms',
	'zoos'
];

export const getBlockFieldsForCatalog = (blocks) =>
	blocks.reduce((memo, value) => {
		const blockFields = memo;

		if (!value.noFields) {
			blockFields[value.blockName] = undefined;
		}

		return blockFields;
	}, {});

export const getCompleteBlocksParamsForCatalog = (blocks, rubricId) =>
	blocks.map(({ blockName, isHide = false }) => {
		const initialParams = {
			limit: 1
		};

		const addUpFinalObject = (blockParams) => ({
			blockName,
			blockParams: {
				...blockParams,
				...(!!rubricId && { rubricPaths: [rubricId] })
			}
		});

		if (!isHide) {
			const sort = entitiesWithViewsSort.includes(blockName)
				? '-views'
				: '-publishDate';

			const blockParams = {
				limit: 3,
				statuses: ['published'],
				sort
			};

			return addUpFinalObject(blockParams);
		}

		return addUpFinalObject(initialParams);
	});
